<div class="row seedfullPage">
  <div class="seedEfulfillmentOuter">

    <div class="seedEfulfillment">
      <div class="order-view-sec breadcrumbOuter padding-0" id="orderView" [ngClass]="{
    'col-md-9':orderViewtoggle == false,
    'col-md-12':orderViewtoggle == true}">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">
              <a href="javascript:void(0)" (click)="navigateToSeedfulfillment()">Fulfillment</a>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item" *ngIf="!isEditMode">
              <span>Order Release Entry</span>
            </li>
            <li class="breadcrumb-item breadcrumbColor" aria-current="page" *ngIf="isEditMode">
              <span>Release ID # {{releaseOrder.ReleaseId}}</span>
              <span *ngIf="isReleased"> [ERPOrder# {{releaseOrder.JDEReleaseOrderNumber}} ]</span>
            </li>
          </ol>
        </nav>
      </div>
      <!--Crop year and filter section-->
      <div class="OrderReleaseTop">
        <div *ngIf="error">
          <div class="row">
            <div class="col-md-12">
              <div class="inline-error" *ngIf="error">
                <div class="row">
                  <div class="col-md-12 padding-l0">
                    <ol class="error-list">
                      <li class="justify-content-center align-self-center" *ngFor="let err of errorsList">
                        {{err}}
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--Ship to - Confirmation Email Section-->
        <div class="row">
          <div class=" col-md-6 material-select withBordr">
            <ng-select name="ddlShipTo"
                       [items]="shipToData"
                       class="custom-select-grower grower-add-drop"
                       [virtualScroll]="true"
                       [(ngModel)]="releaseOrder.ShipToAccount"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       placeholder="Ship To:"
                       [loading]="shipToDataLoading"
                       [closeOnSelect]="true"
                       [disabled]="(isEditMode || isReleased || previousPage === 'SAR' )"
                       [searchFn]="accountSearchFn"
                       (change)="getShipTo($event)"
                       (clear)="getShipTo($event)">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <!--<ng-template ng-notfound-tmp let-searchTerm="searchTerm">
          <div class="ng-option disabled">
            No data found for "{{searchTerm}}"
          </div>
        </ng-template>-->
            </ng-select>
          </div>
          <div class="col-md-6 material-select nonRequired withBordr">
            <ng-select name="ddlDeliverTo"
                       [items]="deliverToData"
                       class="custom-select-grower grower-add-drop"
                       [virtualScroll]="true"
                       [(ngModel)]="releaseOrder.DeliverTo"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       placeholder="Deliver To:"
                       [loading]="deliverToLoading"
                       [closeOnSelect]="true"
                       [searchFn]="accountSearchFn"
                       [disabled]="isReleased || accessTypeMode"
                       (change)="getDeliverToAccount($event)">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 shipTo">
            <div *ngIf="selectedDealer">
              <p>
                Account#: {{selectedDealer.accountNumber}}
              </p>
              <p>
                Address: {{selectedDealer.address1}},  {{selectedDealer.city}}, {{selectedDealer.state}} - {{selectedDealer.zipCode}}
              </p>
            </div>
          </div>
          <div class="col-md-6 shipTo">
            <div *ngIf="deliverTo">
              <p>
                Account#: {{deliverTo.accountNumber}}
              </p>
              <p>
                Address: {{deliverTo.address1}},  {{deliverTo.city}}, {{deliverTo.state}} - {{deliverTo.zipCode}}
              </p>
            </div>
          </div>
        </div>
        <div *ngIf="previousPage != 'SAR'">
          <div class="row margin-t10">
            <div class="col-md-3 material-select withBordr" [class.invalid-field]="validation.BranchPlant">
              <ng-select name="ddlBranch"
                         [items]="branchPlantData"
                         class="custom-select-grower grower-add-drop"
                         [virtualScroll]="true"
                         [(ngModel)]="releaseOrder.BranchPlant"
                         bindLabel="description"
                         placeholder="Branch:"
                         [loading]="branchDataLoading"
                         bindValue="id"
                         [closeOnSelect]="true"
                         [disabled]="(isReleased || accessTypeMode || previousPage === 'SAR' )"
                         (change)="OnBranchPlantChange($event)">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <h4 class="name greenColor" [ngOptionHighlight]="search">
                          {{item.description}}
                        </h4>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>
            <!--<div class="col-md-6">
        <mat-form-field class="wide100 marTop12">
          <input matInput type="email" name="accountEmail"
                 placeholder="Confirmation E-mail:"
                 [(ngModel)]="accountEmail"
                 [pattern]="emailPattern"
                 (keyup)="validateEmail()"
                 [disabled]="isReleased"
                 email="true">
          <mat-error *ngIf="isNotValid">
            Email not valid.
          </mat-error>
        </mat-form-field>
      </div>-->
            <div class="col-md-3 marTop12">
              <mat-form-field [class.invalid-field]="validation.RequestedDate" class="noRequired">
                <mat-label>Requested Date</mat-label>
                <input matInput [readonly]="true" [matDatepicker]="picker" (dateChange)="validateDate($event)" [(ngModel)]="releaseOrder.RequestedDate" placeholder="Requested Date" (focus)="picker.open();" [min]="minDate" [max]="maxDate" [matDatepickerFilter]="dateFilter">
                <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="isReleased || accessTypeMode"></mat-datepicker-toggle>
                <mat-datepicker #picker [disabled]="isReleased || accessTypeMode"></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-md-3 material-select withBordr" [class.invalid-field]="validation.FreightHandlingCode">
              <ng-select name="ddlFreighthandlingCodeDetails"
                         [items]="freightHandlingCodeData"
                         class="custom-select-grower grower-add-drop"
                         [(ngModel)]="releaseOrder.FreightHandlingCode"
                         [virtualScroll]="true"
                         bindLabel="value"
                         placeholder="Freight Handling Code"
                         [loading]="freightHandlingCodeDataLoading"
                         bindValue="id"
                         [closeOnSelect]="true"
                         [disabled]="isReleased || accessTypeMode"
                         (change)="OnFreighthandlingCodeChange($event)">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-4">
                        <h4 class="name greenColor" [ngOptionHighlight]="search">
                          {{item.value}}
                        </h4>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>
            <div class="col-md-3 material-select withBordr" [class.invalid-field]="validation.JDEVersion">
              <ng-select name="ddlRequestType"
                         [items]="requestTypeData"
                         class="custom-select-grower grower-add-drop"
                         [(ngModel)]="releaseOrder.JDEVersion"
                         [virtualScroll]="true"
                         bindLabel="description"
                         placeholder="Request Type"
                         [loading]="requestTypeDataLoading"
                         bindValue="versionId"
                         [disabled]="(isReleased || accessTypeMode || previousPage === 'SAR' )"
                         [closeOnSelect]="true"
                         (change)=getRequestType($event)>
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-4">
                        <h4 class="name greenColor" [ngOptionHighlight]="search">
                          {{item.description}}
                        </h4>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="row margin-t10">
            <div class="col-md-3 deliveryNotes material-select margin-t15 padding-0">
              <!--<ng-select name="ddlDI"
                   [items]="releaseOrder.DeliveryInstructionsList"
                   class="custom-select-grower grower-add-drop"
                   [virtualScroll]="true"
                   [(ngModel)]="releaseOrder.DeliveryCode"
                   bindLabel="description"
                   [placeholder]="deliveryInstructionsText"
                   [loading]="branchDataLoading"
                   bindValue="deliveryCode"
                   [closeOnSelect]="true"
                   [disabled]="isDeliveryInstructionEmpty">
        </ng-select>-->

              <div class="row">

                <i title="Edit" class="icon-ico-edit handCursor col-md-1" [ngClass]="productLineIds.length>0 && isDeliveryInstrcutionAccess && !releaseOrder.JDEReleaseOrderNumber ? 'enableBlue' : 'disableBlue'" (click)="addDeliveryInstruction()"></i>
                <mat-form-field class="wide100 col-md-11" [ngClass]="productLineIds.length>0 && releaseOrder.DeliveryInstructionsNamePhone ? 'enableBlue' : 'disableBlue'">
                  <mat-label>{{productLineIds.length>0 && releaseOrder.DeliveryInstructionsNamePhone ? 'Delivery Instructions:' : 'Delivery Instructions: (Will display after selection of Product)'}}</mat-label>
                  <input matInput type="text" name="deliveryInstructionsCodes" class="pb-1" data-testid="btn-delivery-instructions-codes"
                         [(ngModel)]="releaseOrder.DeliveryInstructionsCodes"
                         [readonly]="isReleased || accessTypeMode"
                         [maxLength]="30">
                </mat-form-field>

                <i title="Clear Delivery Instruction" style=" transform: scale(.7)" *ngIf="releaseOrder.DeliveryInstructionsNamePhone" class="icon-ico-Close handCursor col-md-1" [ngClass]="productLineIds.length>0 && isDeliveryInstrcutionAccess && !releaseOrder.JDEReleaseOrderNumber ? 'enableBlue' : 'disableBlue'" (click)="resetDeliveryInstruction()"></i>
                <div class="col-md-1" *ngIf="!releaseOrder.DeliveryInstructionsNamePhone"> </div>
                <mat-form-field class="wide100" [ngClass]="productLineIds.length>0 && releaseOrder.DeliveryInstructionsNamePhone ? 'col-md-11 paddingl-10 enableBlue' : 'col-md-10 padding-0 disableBlue'">
                  <input matInput type="text" name="deliveryInstructions" class="pb-1"
                         [(ngModel)]="releaseOrder.DeliveryInstructionsNamePhone"
                         [placeholder]="productLineIds.length>0 && releaseOrder.DeliveryInstructionsNamePhone ? '' : 'Click edit icon to add delivery instructions'"
                         [readonly]="isReleased || accessTypeMode"
                         [maxLength]="30">
                </mat-form-field>
              </div>
            </div>
            <div class="col-md-3 customerPO margin-t15">
              <mat-form-field class="wide100">
                <mat-label>Customer PO:</mat-label>
                <input matInput type="text" name="customerPO" class="pb-1"
                       [(ngModel)]="releaseOrder.CustomerPO"
                       [readonly]="isReleased || accessTypeMode"
                       [maxLength]="25">
              </mat-form-field>
            </div>
            <div class="col-md-6 customerPO" *ngIf="!isReleased">
              <div class="row">
                <div class="col-md-6 material-select withBordr">
                  <ng-select name="ddlInventoryType"
                             [items]="inventoryTypeData"
                             class="custom-select-grower grower-add-drop"
                             [(ngModel)]="computeOption"
                             [virtualScroll]="true"
                             bindLabel="value"
                             placeholder="Inventory Compute options"
                             bindValue="id"
                             [disabled]="(previousPage === 'SAR' )"
                             [closeOnSelect]="true">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row">
                          <div class="col-md-4">
                            <h4 class="name greenColor" [ngOptionHighlight]="search">
                              {{item.value}}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
                <div class="col-md-6 margin-t15">
                  <button mat-raised-button class="btns" (click)="computeInventory()" data-testid="btn-compute-inventory2">Compute Inventory</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="previousPage === 'SAR'">
          <div class="row margin-t10">
            <div class="col-md-3 material-select withBordr" [class.invalid-field]="validation.BranchPlant">
              <ng-select name="ddlBranch"
                         [items]="branchPlantData"
                         class="custom-select-grower grower-add-drop"
                         [virtualScroll]="true"
                         [(ngModel)]="releaseOrder.BranchPlant"
                         bindLabel="description"
                         placeholder="Branch:"
                         [loading]="branchDataLoading"
                         bindValue="id"
                         [closeOnSelect]="true"
                         [disabled]="(isReleased || accessTypeMode || previousPage === 'SAR' )"
                         (change)="OnBranchPlantChange($event)">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <h4 class="name greenColor" [ngOptionHighlight]="search">
                          {{item.description}}
                        </h4>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>
            <!--<div class="col-md-6">
    <mat-form-field class="wide100 marTop12">
      <input matInput type="email" name="accountEmail"
             placeholder="Confirmation E-mail:"
             [(ngModel)]="accountEmail"
             [pattern]="emailPattern"
             (keyup)="validateEmail()"
             [disabled]="isReleased"
             email="true">
      <mat-error *ngIf="isNotValid">
        Email not valid.
      </mat-error>
    </mat-form-field>
  </div>-->
            <div class="col-md-3 marTop12">
              <mat-form-field [class.invalid-field]="validation.RequestedDate" class="noRequired">
                <input matInput [readonly]="true" [matDatepicker]="picker" (dateChange)="validateDate($event)" [(ngModel)]="releaseOrder.RequestedDate" placeholder="Requested Date" (focus)="picker.open();" [min]="minDate" [max]="maxDate" [matDatepickerFilter]="dateFilter">
                <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="isReleased || accessTypeMode"></mat-datepicker-toggle>
                <mat-datepicker #picker [disabled]="isReleased || accessTypeMode"></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-md-3 material-select withBordr">
              <ng-select name="ddlPickUpOrder"
                         class="custom-select-grower grower-add-drop"
                         placeholder="Pickup Order"
                         [closeOnSelect]="true"
                         [clearable]="false"
                         [(ngModel)]="pickupOrderValue">
                <ng-option [value]="'yes'">Yes</ng-option>
                <ng-option [value]="'no'">No</ng-option>
              </ng-select>
            </div>
            <div class="col-md-3 material-select withBordr" [class.invalid-field]="validation.FreightHandlingCode">
              <ng-select name="ddlFreighthandlingCodeDetails"
                         [items]="freightHandlingCodeData"
                         class="custom-select-grower grower-add-drop"
                         [(ngModel)]="releaseOrder.FreightHandlingCode"
                         [virtualScroll]="true"
                         bindLabel="value"
                         placeholder="Freight Handling Code"
                         [loading]="freightHandlingCodeDataLoading"
                         bindValue="id"
                         [closeOnSelect]="true"
                         [disabled]="true"
                         (change)="OnFreighthandlingCodeChange($event)">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-4">
                        <h4 class="name greenColor" [ngOptionHighlight]="search">
                          {{item.value}}
                        </h4>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="row margin-t10">
            <div class="col-md-3 deliveryNotes material-select margin-t15 padding-0">
              <!--<ng-select name="ddlDI"
                   [items]="releaseOrder.DeliveryInstructionsList"
                   class="custom-select-grower grower-add-drop"
                   [virtualScroll]="true"
                   [(ngModel)]="releaseOrder.DeliveryCode"
                   bindLabel="description"
                   [placeholder]="deliveryInstructionsText"
                   [loading]="branchDataLoading"
                   bindValue="deliveryCode"
                   [closeOnSelect]="true"
                   [disabled]="isDeliveryInstructionEmpty">
        </ng-select>-->

              <div class="row">

                <i title="Edit" class="icon-ico-edit handCursor col-md-1" [ngClass]="productLineIds.length>0 && isDeliveryInstrcutionAccess && !releaseOrder.JDEReleaseOrderNumber ? 'enableBlue' : 'disableBlue'" (click)="addDeliveryInstruction()"></i>
                <mat-form-field class="wide100 col-md-11" [ngClass]="productLineIds.length>0 && releaseOrder.DeliveryInstructionsNamePhone ? 'enableBlue' : 'disableBlue'">
                  <input matInput type="text" name="deliveryInstructionsCodes" class="pb-1" data-testid="btn-delivery-instructions"
                         [(ngModel)]="releaseOrder.DeliveryInstructionsCodes"
                         [placeholder]="productLineIds.length>0 && releaseOrder.DeliveryInstructionsNamePhone ? 'Delivery Instructions:' : 'Delivery Instructions: (Will display after selection of Product)'"
                         [readonly]="isReleased || accessTypeMode"
                         [maxLength]="30">
                </mat-form-field>

                <i title="Clear Delivery Instruction" style=" transform: scale(.7)" *ngIf="releaseOrder.DeliveryInstructionsNamePhone" class="icon-ico-Close handCursor col-md-1" [ngClass]="productLineIds.length>0 && isDeliveryInstrcutionAccess && !releaseOrder.JDEReleaseOrderNumber ? 'enableBlue' : 'disableBlue'" (click)="resetDeliveryInstruction()"></i>
                <div class="col-md-1" *ngIf="!releaseOrder.DeliveryInstructionsNamePhone"> </div>
                <mat-form-field class="wide100" [ngClass]="productLineIds.length>0 && releaseOrder.DeliveryInstructionsNamePhone ? 'col-md-11 paddingl-10 enableBlue' : 'col-md-10 padding-0 disableBlue'">
                  <input matInput type="text" name="deliveryInstructions" class="pb-1"
                         [(ngModel)]="releaseOrder.DeliveryInstructionsNamePhone"
                         [placeholder]="productLineIds.length>0 && releaseOrder.DeliveryInstructionsNamePhone ? '' : 'Click edit icon to add delivery instructions'"
                         [readonly]="isReleased || accessTypeMode"
                         [maxLength]="30">
                </mat-form-field>
              </div>
            </div>
            <div class="col-md-3 customerPO margin-t15">
              <mat-form-field class="wide100">
                <input matInput type="text" name="customerPO" class="pb-1"
                       [(ngModel)]="releaseOrder.CustomerPO"
                       [readonly]="isReleased || accessTypeMode"
                       placeholder="Customer PO:"
                       [maxLength]="25">
              </mat-form-field>
            </div>
            <div class="col-md-6 customerPO" *ngIf="!isReleased">
              <div class="row">
                <div class="col-md-6 material-select withBordr" [class.invalid-field]="validation.JDEVersion">
                  <ng-select name="ddlRequestType"
                             [items]="requestTypeData"
                             class="custom-select-grower grower-add-drop"
                             [(ngModel)]="releaseOrder.JDEVersion"
                             [virtualScroll]="true"
                             bindLabel="description"
                             placeholder="Request Type"
                             [loading]="requestTypeDataLoading"
                             bindValue="versionId"
                             [disabled]="(isReleased || accessTypeMode || previousPage === 'SAR' )"
                             [closeOnSelect]="true"
                             (change)=getRequestType($event)>
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row">
                          <div class="col-md-4">
                            <h4 class="name greenColor" [ngOptionHighlight]="search">
                              {{item.description}}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>

                <div class="col-md-6 material-select withBordr">
                  <ng-select name="ddlInventoryType"
                             [items]="inventoryTypeData"
                             class="custom-select-grower grower-add-drop"
                             [(ngModel)]="computeOption"
                             [virtualScroll]="true"
                             bindLabel="value"
                             placeholder="Inventory Compute options"
                             bindValue="id"
                             [disabled]="(previousPage === 'SAR' )"
                             [closeOnSelect]="true">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row">
                          <div class="col-md-4">
                            <h4 class="name greenColor" [ngOptionHighlight]="search">
                              {{item.value}}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 margin-t15">
                </div>
                <div class="col-md-6 margin-t15">
                  <button mat-raised-button class="btns" (click)="computeInventory()" data-testid="btn-compute-inventory">Compute Inventory</button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="OrderReleaseDetail">
        <!--Product Detail section-->
        <div class="form-sec">

          <div class="row margin-r0 margin-b20">
            <div class="col-md-8 col-lg-9 product-filter-outer">
              <div class="product-filter-outer">
                <div class="product-filter col-md-12">
                  <div class="search-category">
                    <div class="brand-dropdown default-select">
                      <ng-select [items]="searchTypeList"
                                 name="ddlProductSearch"
                                 [(ngModel)]="productSearchFilter"
                                 [virtualScroll]="true"
                                 [closeOnSelect]="true"
                                 [selectOnTab]="true"
                                 [clearable]="false"
                                 bindLabel="name"
                                 bindValue="value"
                                 [searchable]="false"
                                 (change)="keepFilter()"
                                 placeholder="Select Category">
                      </ng-select>
                    </div>
                  </div>
                  <div class="search-box">
                    <div class="row margin-0">
                      <div class="default-select select-container">
                        <div *ngIf="productSearchFilter === 'ProductNameFilter'">
                          <div class="searchInputBox">
                            <span class="search-icon">
                              <i class="fas fa-search"></i>
                            </span>
                            <div class="select-container">
                              <input (keyup.enter)="selectProductName($event)" [(ngModel)]="productFilters.ProductNameFilter" placeholder="Search...">
                            </div>
                          </div>
                        </div>
                        <div *ngIf="productSearchFilter === 'itemNumber'">
                          <div class="searchInputBox">
                            <span class="search-icon">
                              <i class="fas fa-search"></i>
                            </span>
                            <div class="select-container">
                              <input (keyup.enter)="selectItemNumber($event)" [(ngModel)]="productFilters.itemNumber" placeholder="Search...">
                            </div>
                          </div>
                        </div>
                        <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'marketingBrand'"
                                   [items]="marketingMasterList"
                                   placeholder="Search..."
                                   class="custom-select-grower"
                                   [multiple]="true"
                                   [hideSelected]="true"
                                   [(ngModel)]="productFilters.MarketingBrandList"
                                   [virtualScroll]="true"
                                   bindLabel="value"
                                   bindValue="value"
                                   [closeOnSelect]="true"
                                   [searchFn]="filterSearchFn"
                                   (change)="keepFilter()">
                          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div class="dropdown-template">
                              <div class="row">
                                <div class="col-md-8">
                                  <p class="name">
                                    {{item.value}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                            <div class="ng-option disabled">
                              No data found for "{{searchTerm}}"
                            </div>
                          </ng-template>
                        </ng-select>
                        <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'seedSize'"
                                   [items]="seedSizeMasterList"
                                   placeholder="Search..."
                                   class="custom-select-grower"
                                   [multiple]="true"
                                   [hideSelected]="true"
                                   [(ngModel)]="productFilters.SeedSizeList"
                                   [virtualScroll]="true"
                                   bindLabel="value"
                                   bindValue="value"
                                   [closeOnSelect]="true"
                                   [searchFn]="filterSearchFn"
                                   (change)="keepFilter()">
                          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div class="dropdown-template">
                              <div class="row">
                                <div class="col-md-8">
                                  <p class="name">
                                    {{item.value}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                            <div class="ng-option disabled">
                              No data found for "{{searchTerm}}"
                            </div>
                          </ng-template>
                        </ng-select>
                        <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'packageSize'"
                                   [items]="packageSizeMasterList"
                                   placeholder="Search..."
                                   class="custom-select-grower"
                                   [multiple]="true"
                                   [hideSelected]="true"
                                   [(ngModel)]="productFilters.PackageSizeList"
                                   [virtualScroll]="true"
                                   bindLabel="value"
                                   bindValue="value"
                                   [closeOnSelect]="true"
                                   [searchFn]="filterSearchFn"
                                   (change)="keepFilter()">
                          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div class="dropdown-template">
                              <div class="row">
                                <div class="col-md-8">
                                  <p class="name">
                                    {{item.value}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                            <div class="ng-option disabled">
                              No data found for "{{searchTerm}}"
                            </div>
                          </ng-template>
                        </ng-select>
                        <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'productCategory'"
                                   [items]="productCategoryMasterList"
                                   placeholder="Search..."
                                   class="custom-select-grower"
                                   [multiple]="true"
                                   [hideSelected]="true"
                                   [(ngModel)]="productFilters.ProductCategoryList"
                                   [virtualScroll]="true"
                                   bindLabel="value"
                                   bindValue="value"
                                   [closeOnSelect]="true"
                                   [searchFn]="filterSearchFn"
                                   (change)="keepFilter()">
                          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div class="dropdown-template">
                              <div class="row">
                                <div class="col-md-8">
                                  <p class="name">
                                    {{item.value}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                            <div class="ng-option disabled">
                              No data found for "{{searchTerm}}"
                            </div>
                          </ng-template>
                        </ng-select>
                        <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'treatment'"
                                   [items]="treatmentMasterList"
                                   placeholder="Search..."
                                   class="custom-select-grower"
                                   [multiple]="true"
                                   [hideSelected]="true"
                                   [(ngModel)]="productFilters.TreatmentList"
                                   [virtualScroll]="true"
                                   bindLabel="value"
                                   bindValue="value"
                                   [closeOnSelect]="true"
                                   [searchFn]="filterSearchFn"
                                   (change)="keepFilter()">
                          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div class="dropdown-template">
                              <div class="row">
                                <div class="col-md-8">
                                  <p class="name">
                                    {{item.value}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                            <div class="ng-option disabled">
                              No data found for "{{searchTerm}}"
                            </div>
                          </ng-template>
                        </ng-select>
                        <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'productLine'"
                                   [items]="productLineMasterList"
                                   placeholder="Search..."
                                   class="custom-select-grower"
                                   [multiple]="true"
                                   [hideSelected]="true"
                                   [(ngModel)]="productFilters.ProductLineList"
                                   [virtualScroll]="true"
                                   bindLabel="value"
                                   bindValue="value"
                                   [disabled]="previousPage === 'SAR'"
                                   [closeOnSelect]="true"
                                   [searchFn]="filterSearchFn"
                                   (change)="keepFilter()">
                          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div class="dropdown-template">
                              <div class="row">
                                <div class="col-md-8">
                                  <p class="name">
                                    {{item.value}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                            <div class="ng-option disabled">
                              No data found for "{{searchTerm}}"
                            </div>
                          </ng-template>
                        </ng-select>
                        <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'productSegment'"
                                   [items]="productSegmentMasterList"
                                   placeholder="Search..."
                                   class="custom-select-grower"
                                   [multiple]="true"
                                   [hideSelected]="true"
                                   [(ngModel)]="productFilters.ProductSegmentList"
                                   [virtualScroll]="true"
                                   bindLabel="value"
                                   bindValue="value"
                                   [closeOnSelect]="true"
                                   [searchFn]="filterSearchFn"
                                   (change)="keepFilter()">
                          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div class="dropdown-template">
                              <div class="row">
                                <div class="col-md-8">
                                  <p class="name">
                                    {{item.value}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                            <div class="ng-option disabled">
                              No data found for "{{searchTerm}}"
                            </div>
                          </ng-template>
                        </ng-select>
                        <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'hybridVariety'"
                                   [items]="hybridVarietyMasterList"
                                   placeholder="Search..."
                                   class="custom-select-grower"
                                   [multiple]="true"
                                   [hideSelected]="true"
                                   [(ngModel)]="productFilters.HybridVarietyList"
                                   [virtualScroll]="true"
                                   bindLabel="value"
                                   bindValue="value"
                                   [closeOnSelect]="true"
                                   [searchFn]="filterSearchFn"
                                   (change)="keepFilter()">
                          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div class="dropdown-template">
                              <div class="row">
                                <div class="col-md-8">
                                  <p class="name">
                                    {{item.value}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                            <div class="ng-option disabled">
                              No data found for "{{searchTerm}}"
                            </div>
                          </ng-template>
                        </ng-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row chips-sec" *ngIf="(!editToolKit || selectedCount<=0 || isSearchClicked) && filterValueList != '' ">
                  <div class="col-sm-9 col-md-10 selected-chip">
                    <mat-chip-set>
                      <mat-chip selected *ngFor="let filterValue of filterValueList">
                        {{filterValue}}
                        <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                          <i class="fas fa-times text-right"></i>
                        </a>
                      </mat-chip>
                    </mat-chip-set>
                  </div>
                  <div class="col-sm-3 col-md-2 text-right">
                    <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-lg-3 text-right padding-r0 showProdTxt padding-t10" *ngIf="!isReleased && !accessTypeMode" [ngStyle]="isInventoryVisible ? {} : {color: '#c5c5c5'}">
              Show products with inventory availability <mat-checkbox class="custom-checkbox margin-l10" [disabled]="!isInventoryVisible" #chkAvailability (change)="checkAvailability(chkAvailability._checked)" [(ngModel)]="enable"></mat-checkbox>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 productTableOuter">
            <div class="tableContainer">
              <table mat-table [dataSource]="orderReleaseDS" multiTemplateDataRows class="matTables productTable">
                <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                  <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="prod-name">Product / Item#</th>
            </div>
            <div *ngIf="column=='totalOrderUnits'"><th mat-header-cell *matHeaderCellDef class="total-units text-center">Total Order Units</th></div>
            <div *ngIf="column=='conversionFactor'"><th mat-header-cell *matHeaderCellDef class="convFactor text-center">Conversion Factor</th></div>
            <div *ngIf="column=='hardSoft'"><th mat-header-cell *matHeaderCellDef class="hard-soft-release text-center">Hard / Soft</th></div>
            <div *ngIf="column=='eaModifiableUnit' && isEaEligible == true"><th mat-header-cell *matHeaderCellDef class="eaModify text-center">EA Modifiable Units</th></div>
            <div *ngIf="column=='inventory'"><th mat-header-cell *matHeaderCellDef class="hard-soft-release text-center">Inventory</th></div>
            <div *ngIf="column=='availableToRelease'"><th mat-header-cell *matHeaderCellDef class=" availableToRelease text-center">Available to Release</th></div>
            <div *ngIf="column=='releaseQty'"><th mat-header-cell *matHeaderCellDef class="text-center releaseQuantity">Release Qty</th></div>
            <div [ngStyle]="column=='iconsDisplay' ? {visibility: visible} : {visibility: hiden}"><th mat-header-cell *matHeaderCellDef class="text-left icon-display padding-l0"></th></div>

            <td mat-cell *matCellDef="let element">

              <div *ngIf="column=='product'" class="productName" (click)="expandedElement = expandedElement === element ? null : element; element.selected = 'product'">
                <div matTooltip="Show item details" [matTooltipPosition]="'left'">
                  <p> {{element.brand}} - {{element.marketingBrand}} {{space3}} [{{element.itemNumber}}]</p>
                  <p class="grower-name">
                    {{element.itemDescription}}
                  </p>
                </div>
              </div>

              <div *ngIf="column=='totalOrderUnits'" class="available-block text-center">
                <div>
                  <span class="seed-avail" *ngIf="element.dealerUnits>=0">{{element.dealerUnits | number}}</span>
                  <span class="seed-avail" *ngIf="element.dealerUnits<0">({{element.dealerUnits | positiveValue | number}})</span>
                </div>
              </div>

              <div *ngIf="column=='conversionFactor'" class="text-center">
                <div>
                  <span> {{element.conv}}</span>
                </div>
              </div>

              <div *ngIf="column=='hardSoft'" class="text-center">
                <span class="oval-shape">
                  {{element.hardQuantity}} / {{element.softQuantity}}
                </span>
              </div>
              <div *ngIf="isEaEligible == true && column=='eaModifiableUnit'" class="text-center">
                <span>
                  {{element.eaModifiableUnit | number}}
                </span>
              </div>

              <div *ngIf="column=='inventory'" class="text-center">
                <div>
                  <span> {{element.inventoryQty | number}}</span>
                </div>
              </div>

              <div *ngIf="column=='availableToRelease'" class="text-center">
                <div>
                  <span> {{element.availableUnits | number}}</span>
                </div>
              </div>

              <div *ngIf="column=='releaseQty'" class="text-center">
                <div>
                  <button (click)="dealerUnitChange('decrease',element);element.isSelected=true" class="plus-minus-btn minusBtn" *ngIf="!isReleased && !accessTypeMode"> - </button>
                  <input type="text" class="geu-txt padding-t2" [(ngModel)]="element.releaseQuantity" [readonly]="isReleased || accessTypeMode" (focusout)="validateLineItem(element,'releaseUnit')" maxlength="5" NumbersOnly />
                  <button (click)="dealerUnitChange('increase',element); element.isSelected=true" class="plus-minus-btn plusBtn" *ngIf="!isReleased && !accessTypeMode"> + </button>
                </div>
              </div>
              <div *ngIf="column=='iconsDisplay' && element.releaseQuantity > 0 && !isReleased" style="margin-left: -40px;">
                <button mat-button [matMenuTriggerFor]="beforeMenu1" class="context-menu">
                  <i class="fas fa-ellipsis-v blue-color"></i>
                </button>
                <mat-menu #beforeMenu1="matMenu" xPosition="before" class="context-meun-dropdown">
                  <button mat-menu-item (click)="openSeedFulfillmentBreakdown(element, 'V')" [disabled]="element.isBulk=='Y'" data-testid="btn-view-lots">View Lots</button>
                  <button mat-menu-item (click)="openSeedFulfillmentBreakdown(element, 'E')" [disabled]="element.isBulk != 'Y'" data-testid="btn-edit-lots">Edit Lots</button>
                </mat-menu>
              </div>
            </td>
            </ng-container>

            <ng-container matColumnDef="expandedDetail">
              <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                <!--<div class="expendedBlock">
                </div>-->

                <div class="example-element-detail"
                     [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                  <div class="product-detail-info-outer" *ngIf='element.selected == "product"' [ngClass]="{'prodDetailWithUnit': element.selected == 'product' && element.isSelected == true}">
                    <div class="product-detail-info">
                      <span class="arrowTip productTip">
                        <i class="fas fa-sort-up"></i>
                      </span>
                      <table>
                        <thead>
                          <!--<th class="text-left">Item#</th>-->
                        <th>Technology</th>
                        <th>Treatment</th>
                        <th class="text-center">Seed Size</th>
                        <th class="text-center">Package Size</th>
                        <th class="text-center">Maturity</th>
                        <th class="text-center">Marketing Brand</th>
                        </thead>
                        <tbody>
                          <tr>
                            <!--<td class="text-left">{{element.itemNumber}}</td>-->
                            <td>
                              <span [ngClass]="{'oval-shape technology': (element.highlightTechnology===1)}" matTooltip="{{element.technology}}" [matTooltipPosition]="'above'">
                                {{element.technology}}
                              </span>
                            </td>
                            <td>
                              <span [ngClass]="{'oval-shape treatment': (element.highlightTreatment===1)}" matTooltip="{{element.treatment}}" [matTooltipPosition]="'above'">
                                {{element.treatment}}
                              </span>
                            </td>
                            <td class="text-center">{{element.seedSize}}</td>
                            <td class="text-center">
                              <span [ngClass]="{'oval-shape pack-size': (element.highlightPackage===1)}" matTooltip="{{element.packageSize}}" [matTooltipPosition]="'above'">
                                {{element.packageSize}}
                              </span>
                            </td>
                            <td class="text-center">{{element.maturity}}</td>
                            <td class="text-center">{{element.marketingBrand}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="inline-error" *ngIf="element.lineErrors.errors.length > 0" id="error_{{element.lineErrors.rowId}}">
                  <div class="row">
                    <div class="col-md-9">
                      <ol class="error-list">
                        <li *ngFor="let err of element.lineErrors.errors">
                          {{err.error}}
                      </ol>
                    </div>
                    <div class="col-md-3 revertToPrev" (click)="revertToPreviousError(element, true)">
                      <span>
                        Revert to Previous.
                        <i class="icon-ico-Reply"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </td>
            </ng-container>
            <!--<tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row" [style.display]="row?.lineErrors ? 'table-row' : 'none'"></tr>-->

            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns;"
                class="example-element-row"
                [class.example-expanded-row]="expandedElement === element"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!--Requested Pallettes section-->
    <div class="OrderReleaseDetail padding-t0">
      <div class="requestPallet margin-t30 col-12">
        <div class="row">
          <div class="col-4" *ngIf="!isPalletSectionShow"></div>
          <div class="col-5" *ngIf="isPalletSectionShow">
            <div class="row margin-b10">
              <div class="col-md-5 padding-l0 padding-r0">
                <h6>Requested Pallets and Charges</h6>
              </div>
              <div class="showChangesSection col-md-4 padding-r0 padding-t2" [ngStyle]="{'pointer-events':isReleased ? 'none':'auto'}">
                <div class="toggleColor">
                  <span class="padding-r10" style="color: #004E7A;">OVERRIDE: <b style="color: #004E7A;"> {{isOverride?"ON":"OFF"}}</b> </span>
                  <label class="switch">
                    <input type="checkbox" checked>
                    <span class="slider round" (click)="toggleOverrideOnly()" checked="false"></span>
                  </label>
                </div>
              </div>
              <div class="col-md-3 padding-r0 text-right">
                <button type="button" mat-raised-button class="btns" color="primary" (click)="addPalletType()" [disabled]="!isOverride" data-testid="btn-add-pallets">Add Pallets</button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 padding-l0 padding-r0">
                <div class="requestPalletTable">
                  <table class="matTables mat-table" style="border-bottom: none; border-left: none;">
                    <thead>
                      <tr class="mat-header-row">
                        <th class="mat-header-cell type brdrRight borderLeft">
                          Type
                        </th>
                        <th class="mat-header-cell text-center brdrRight bgGray">
                          Quantity
                        </th>
                        <th class="mat-header-cell text-center bgGray" *ngIf="!isReleased || accessTypeMode">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="mat-row" *ngFor="let arrayitem of palletArrayItems;let i=index">
                        <td class="mat-cell brdrRight borderLeft">
                          <div class="material-select requestPalletSelect withBordr">
                            <ng-select *ngIf="arrayitem['palletType']==''" name="ddlPalletType"
                                       [items]="palletTypeData"
                                       class="custom-select-grower grower-add-drop"
                                       [virtualScroll]="true"
                                       [(ngModel)]="arrayitem['itemId']"
                                       bindLabel="value"
                                       placeholder="Pallet Type:"
                                       [loading]="palletTypeLoading"
                                       bindValue="id"
                                       [closeOnSelect]="true"
                                       [disabled]="isReleased || accessTypeMode || !this.isOverride"
                                       (clear)="arrayitem['palletQuantity']=0"
                                       (change)="setPalletItem($event, arrayitem['rowId'], arrayitem['palletQuantity'])">
                              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                <div class="dropdown-template">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h4 class="name" [ngOptionHighlight]="search">
                                        {{item.value}}
                                      </h4>
                                    </div>
                                  </div>
                                </div>
                              </ng-template>
                            </ng-select>
                            <span *ngIf="arrayitem['palletType']!=''" style="color: #004E7A;">{{arrayitem['palletType']}}</span>
                          </div>
                        </td>
                        <td [ngClass]="isReleased == true ? 'mat-cell text-center brdrRight' : 'mat-cell text-right brdrRight'">
                          <mat-form-field style="width: 80px; text-align: center !important;" [appearance]="isReleased || accessTypeMode || !this.isOverride ? 'none':'legacy'">
                            <input matInput type="text" class="geu-txt" [(ngModel)]="arrayitem['palletQuantity']" (keyup)="palletQuantityChange(arrayitem['rowId'], arrayitem['palletQuantity'])"
                                   [readonly]="isReleased || accessTypeMode || !this.isOverride" maxlength="5" NumbersOnly>
                          </mat-form-field>
                        </td>
                        <td class="mat-cell text-center" *ngIf="!isReleased || accessTypeMode">
                          <div class="delete-button" *ngIf="this.isOverride">
                            <span (click)="removePalletItem(i)" matTooltip="Delete" [matTooltipPosition]="'above'">
                              <i class="icon-ico-trash"></i>
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr *ngIf="palletArrayItems.length == 0">
                        <td colspan="3" class="mat-cell text-center borderLeft borderBottom" style="color: #004E7A; padding-top: 12px; padding-bottom: 12px; border-bottom: 1px solid #e5e1dc;">
                          No Pallets added to request
                        </td>
                      </tr>
                      <tr class="mat-row" *ngIf="palletArrayItems.length == 0">
                        <td [ngClass]="palletArrayItems.length == 0 ? 'noBorder':''" class="mat-cell text-right brdrRight bgGray padding-r0" style="padding-top: 12px; padding-bottom: 12px;">
                          <span style="background: #ECE8E5; padding: 16px 24px; color: #004E7A; ">Pallet Count:</span>
                        </td>
                        <td class="mat-cell text-right brdrRight">
                        </td>
                        <td class="mat-cell text-right brdrRight">
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="col-1" *ngIf="isPalletSectionShow"></div>
          <div class="col-3">
            <div class="row margin-b10">
              <div class="padding-l0">
                <h6>Shipment Weight Computation</h6>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 padding-l0 padding-r0">
                <div class="requestPalletTable">
                  <table class="matTables mat-table">
                    <tr class="mat-header-row">
                      <th class="mat-header-cell type brdrRight">
                        Seed Weight
                      </th>
                      <th class="mat-header-cell text-right brdrRight ">
                        {{totalSeedWeight}}
                      </th>
                      <th class="mat-header-cell text-center">
                        Pounds
                      </th>
                    </tr>
                    <tr class="mat-header-row" *ngIf="isPalletSectionShow">
                      <th class="mat-header-cell type brdrRight">
                        Pallet Weight
                      </th>
                      <th class="mat-header-cell text-right brdrRight ">
                        {{totalPalletWeight}}
                      </th>
                      <th class="mat-header-cell text-center">
                        Pounds
                      </th>
                    </tr>
                    <tr class="mat-header-row">
                      <th class="mat-header-cell type brdrRight">
                        Total Weight
                      </th>
                      <th class="mat-header-cell text-right brdrRight ">
                        {{totalComputedWeight}}
                      </th>
                      <th class="mat-header-cell text-center">
                        Pounds
                      </th>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="col-2"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="common-error-block" *ngIf="showErrorBlock && errorMsgs.length>0 && errorMsgs[index].errors.length > 0">
    <div class="row">
      <div class="col-md-2 padding-r0 errCountOuter">
        <!--<span class="close-icon">
          <i class="icon-ico-Error"></i>
        </span>-->
        <span class="errorCounting">
          {{currentErrorRow}} of {{errorMsgs.length}}
        </span>
      </div>
      <div class="col-md-6 padding-l0 ">
        <ul class="errorMsg">
          <li *ngFor="let err of errorMsgs[index].errors">
            <p> {{err.error}}</p>
          </li>
        </ul>
      </div>
      <div class="col-md-4 button-sec text-right">
        <button mat-raised-button class="btns" color="primary" (click)="revertAllChanges()" data-testid="btn-revert-errors">Revert All Errors</button>
        <button mat-raised-button class="btns" color="primary" *ngIf="errorMsgs && errorMsgs.length>0" (click)="nextError()" data-testid="btn-next-error">Next Error</button>
      </div>
    </div>
  </div>
  <div class="SeedFulfillBtnSec">
    <div class="row">
      <div class="col-md-12">
        <button mat-raised-button class="btns" [disabled]="!canSaveData || !canSaveAndReleaseOrder" *ngIf="!isReleased && !accessTypeMode" (click)="placeJdeOrder()" data-testid="btn-place-erp-order">Place ERP Order</button>
        <button mat-raised-button class="btns" id="btn-save-release" color="primary" [disabled]="!canSaveData" *ngIf="!isReleased && !accessTypeMode && previousPage != 'SAR'" (click)="saveReleaseOrder()" data-testid="btn-save-release">Save Release</button>
        <button mat-raised-button class="btns" color="primary" [disabled]="isComputeDisabled" *ngIf="!isReleased && !accessTypeMode" (click)="computePalletAndSeedWeight()" data-testid="btn-compute-pallets">Compute Pallets and Weight</button>
        <button mat-raised-button class="btns" *ngIf="!accessTypeMode" color="primary" (click)="navigateToSeedfulfillment()" data-testid="btn-seed-fulfillment-cancel">Cancel</button>
      </div>
    </div>
  </div>
</div>
</div>
